import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '@/redux/action';
import Utils from '@/utils';
import { request } from '@/api/request';
import sentGAEvent from '@/ga';
import { api_config } from '@/constants/api';
import Cookies from 'js-cookie';
import api_domain_config from '@/constants/common';
import { accountList } from '@/constants/url';
import ConvertWorkFunction from './chidren/ConvertWorkFunction';

import '@/assets/convert.less';

class ConvertWork extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.convertChild = React.createRef();
  }

  // handlePurchaseModalObjChange = (purchaseModalObj) => {
  //   this.props.onPurchaseModalObjChange(purchaseModalObj);
  // };
  handleFilesChange = (files) => {
    const newFiles = [...files];
    this.props.onFilesChange(newFiles);
  };

  handleSubmitAgain = async (guid) => {
    const files = [...this.props.files];
    const filterFiles = files.filter((item) => item.guid === guid);
    if (filterFiles.length) {
      if (filterFiles[0].status === 'convertFailed') {
        filterFiles[0].status = 'converting';
        filterFiles[0].proccessStep = 1;
        this.handleFilesChange(files);
        this.handleConvert(files, filterFiles[0], filterFiles[0].fileurl);
      } else {
        filterFiles[0].status = 'uploading';
        filterFiles[0].proccessStep = 3;
        this.handleFilesChange(files);
        this.handleUploading(files, filterFiles[0]);
      }
    }
    console.log(filterFiles);
  };

  handleSubmit = async () => {
    const files = [...this.props.files];
    const filterFiles = files.filter((item) => item.status !== 'success');
    for (let i = 0; i < filterFiles.length; i++) {
      console.log(filterFiles[i].fileObj);
      sentGAEvent({
        category: 'Convert',
        action: 'ConvertSave',
        label: filterFiles[i].fileObj.name
          ? /\.[^.]+$/
              .exec(filterFiles[i].fileObj.name)[0]
              .toLocaleLowerCase()
              .replace('.', '') +
            '_' +
            filterFiles[i].convertType
          : 'mp4_' + filterFiles[i].convertType,
      });
      filterFiles[i].startTime = new Date();
      this.handleFilesChange(files);
      if (filterFiles[i].uploadStatus) {
        let code = await this.handleConvert(
          files,
          filterFiles[i],
          filterFiles[i].videofileurl
        );
        if (code === 402102) {
        }
      } else {
        let code = await this.handleUploading(files, filterFiles[i]);
        if (code === 402102) {
        }
      }
    }
  };

  // 上传并convert
  handleUploading = async (files, file) => {
    let fileResponse, apiUrl;
    file.status = 'uploading';
    this.handleFilesChange(files);
    try {
      if (file.fileType === 'video') {
        fileResponse = await this.requestUploadVideoFile(
          file.fileObj,
          this.handleChangeProgress,
          file.guid
        );
        apiUrl = 'uploadVideo';
      } else if (file.fileType === 'audio') {
        fileResponse = await this.requestUploadAudioFile(
          file.fileObj,
          this.handleChangeProgress,
          file.guid
        );
        apiUrl = 'uploadAudio';
      } else {
        fileResponse = await this.requestUploadImageFile(
          file.fileObj,
          this.handleChangeProgress,
          file.guid
        );
        apiUrl = 'uploadImage';
      }
    } catch (error) {
      if (error !== 'cancel') {
        file.status = 'uploadFailed';
        file.proccess = 0;
        this.handleFilesChange(files);
      }
      console.log(error);
      return false;
    }
    if (fileResponse.code === 200) {
      sentGAEvent({
        category: 'Upload',
        action: 'LocalSerSuccess',
      });
      let action;
      if (this.props.type === 'image') {
        action = '34IC_UploadSuccess';
      } else if (this.props.type === 'audio') {
        action = '29AC_UploadSuccess';
      } else {
        action = '36VC_UploadSuccess';
      }
      if (action) {
        sentGAEvent({
          category: 'UploadSuccess',
          action: action,
          label: 'Null',
        });
      }
      if (fileResponse.data.result.number) {
        const fileResponseNumber = fileResponse.data.result.number;
        const fileResponseUrl = fileResponse.data.response_file[0];
        // let progressResponse;
        file.proccessNum = fileResponseNumber;
        file.status = 'converting';
        file.fileurl = fileResponseUrl;
        this.handleFilesChange(files);
        try {
          await Utils.getProgress(
            fileResponseNumber,
            false,
            this.handleChangeProgress,
            file.guid
          );
        } catch (error) {
          if (error !== 'cancel') {
            sentGAEvent({
              category: 'Upload',
              action: 'LocalSerFail',
              label: apiUrl + '_200_200_' + error,
            });
          }
          file.status = 'uploadFailed';
          file.proccess = 0;
          this.handleFilesChange(files);
          return false;
        }
        let code = await this.handleConvert(files, file, fileResponseUrl);
        if (code === 402102) {
          return 402102;
        }
      }
    } else {
      if (fileResponse.code === 401) {
        Cookies.remove('authorization', { domain: api_domain_config.DOMAIN });
        let hostName = window.location.hostname;
        Cookies.remove('access_token', {
          domain: hostName.substring(
            window.location.hostname.indexOf('.'),
            hostName.length
          ),
        });
        Cookies.remove('access_token_expires_in', {
          domain: hostName.substring(hostName.indexOf('.'), hostName.length),
        });
        window.location.replace(
          `${accountList.get('login')}?redirect=${window.location.href}`
        );
      }
      file.status = 'uploadFailed';
      file.proccess = 0;
      this.handleFilesChange(files);
      sentGAEvent({
        category: 'Upload',
        action: 'LocalSerFail',
        label:
          apiUrl +
          '_200_' +
          fileResponse.code +
          '_none_' +
          this.props.tokenId +
          '_none_' +
          fileResponse.msg,
      });
      if (fileResponse.code === 401) {
        Cookies.remove('authorization', { domain: api_domain_config.DOMAIN });
        let hostName = window.location.hostname;
        Cookies.remove('access_token', {
          domain: hostName.substring(
            window.location.hostname.indexOf('.'),
            hostName.length
          ),
        });
        Cookies.remove('access_token_expires_in', {
          domain: hostName.substring(hostName.indexOf('.'), hostName.length),
        });
        window.location.replace(
          `${accountList.get('login')}?redirect=${window.location.href}`
        );
      }
    }
  };

  //仅仅convert
  handleConvert = async (files, file, fileResponseUrl) => {
    file.status = 'converting';
    this.handleFilesChange(files);
    let convertResponse;
    let gaAction;
    if (this.props.type === 'image') {
      gaAction = '34IC_ProcessStart';
    } else if (this.props.type === 'audio') {
      gaAction = '29AC_ProcessStart';
    } else {
      gaAction = '36VC_ProcessStart';
    }

    try {
      convertResponse = await this.requstConvert(
        file.convertType,
        fileResponseUrl
      );
    } catch (error) {
      if (error !== 'cancel') {
        file.status = 'convertFailed';
        file.proccess = 0;
        this.handleFilesChange(files);
      }
      return false;
    }
    if (convertResponse.code === 200) {
      sentGAEvent({
        category: 'ProcessStart',
        action: gaAction,
        label: 'Null',
      });
      const convertResponseNumber = convertResponse.data.result.number;
      const convertResponseUrl = convertResponse.data.response_file[0];
      if (this.props.type !== 'image') {
        let convertProgressResponse;
        file.proccessNum = convertResponseNumber;
        this.handleFilesChange(files);
        try {
          convertProgressResponse = await Utils.getProgress(
            convertResponseNumber,
            false,
            this.handleChangeProgress,
            file.guid,
            'convertImage'
          );
        } catch (error) {
          if (error !== 'cancel') {
            file.status = 'convertFailed';
            file.proccess = 0;
            this.handleFilesChange(files);
            sentGAEvent({
              category: 'Convert',
              action: 'ConvertFail',
              label: 'formatConv_200_200_' + error,
            });
          }
          return false;
        }
        file.newSize = parseInt(convertProgressResponse.info[0].size);
      }
      file.status = 'success';
      file.newName = file.name.split('.')[0] + '.' + file.convertType;
      file.fileurl = convertResponseUrl;
      this.handleFilesChange(files);
      sentGAEvent({
        category: 'Convert',
        action: 'ConvertSuccess',
      });
      let action;
      if (this.props.type === 'image') {
        action = '34IC_ProcessSuccess';
      } else if (this.props.type === 'audio') {
        action = '29AC_ProcessSuccess';
      } else {
        action = '36VC_ProcessSuccess';
      }
      if (action) {
        sentGAEvent({
          category: 'ProcessSuccess',
          action: action,
          label: 'Null',
        });
      }
    } else {
      if (convertResponse.code === 402102) {
        // this.convertChild.current.handleAddFileMoreThanLimit1()
        file.status = 'ready';
        file.proccess = 0;
        this.handleFilesChange(files);
        sentGAEvent({
          category: 'Convert',
          action: 'ConvertFail',
          label:
            'formatConv_200_' +
            convertResponse.code +
            '_none_' +
            this.props.tokenId +
            '_none_' +
            convertResponse.msg,
        });
        return 402102;
      } else if (convertResponse.code === 400404) {
        this.convertChild.current.handleAddFileMoreThanLimit1();
        file.status = 'ready';
        file.proccess = 0;
        this.handleFilesChange(files);
        return 402102;
      } else {
        file.status = 'convertFailed';
        file.proccess = 0;
        this.handleFilesChange(files);
        sentGAEvent({
          category: 'Convert',
          action: 'ConvertFail',
          label:
            'formatConv_200_' +
            convertResponse.code +
            '_none_' +
            this.props.tokenId +
            '_none_' +
            convertResponse.msg,
        });
      }
    }
  };

  requestUploadVideoFile = (file, callback, guid) => {
    sentGAEvent({
      category: 'Upload',
      action: 'LocalSerStart',
    });
    let action;
    if (this.props.type === 'image') {
      action = '34IC_UploadStart';
    } else if (this.props.type === 'audio') {
      action = '29AC_UploadStart';
    } else {
      action = '36VC_UploadStart';
    }
    sentGAEvent({
      category: 'UploadStart',
      action: action,
      label: 'Null',
    });

    const formData = new FormData();
    formData.append('files[]', file);
    formData.append('token', this.props.tokenId);
    // this.props.onUploadPercentChange(1);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${api_config.API_URL}/uploadVideo`, true);
      xhr.setRequestHeader('authorization', this.props.authorization);
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          // this.props.onUploadPercentChange(parseInt((event.loaded / event.total) * 100));
          callback(parseInt((event.loaded / event.total) * 100), guid);
        }
      };
      xhr.onerror = () => {
        reject('uploadVideo_' + xhr.status);
      };
      xhr.onabort = () => {
        reject('cancel');
      };
      xhr.upload.onabort = () => {
        reject('cancel');
      };
      xhr.onload = () => {
        resolve(JSON.parse(xhr.response));
      };
      xhr.send(formData);
      this.setState({ uploadXHR: xhr });
      this.props.onUploadXHRChange(xhr);
    });
  };

  requestUploadAudioFile = (file, callback, guid) => {
    let action;
    if (this.props.type === 'image') {
      action = '34IC_UploadStart';
    } else if (this.props.type === 'audio') {
      action = '29AC_UploadStart';
    } else {
      action = '36VC_UploadStart';
    }
    sentGAEvent({
      category: 'UploadStart',
      action: action,
      label: 'Null',
    });

    const formData = new FormData();
    formData.append('files[]', file);
    formData.append('token', this.props.tokenId);
    // this.props.onUploadPercentChange(1);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${api_config.API_URL}/uploadAudio`, true);
      xhr.setRequestHeader('authorization', this.props.authorization);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          // this.props.onUploadPercentChange(parseInt((event.loaded / event.total) * 100));
          callback(parseInt((event.loaded / event.total) * 100), guid);
        }
      };
      xhr.onerror = () => {
        reject('uploadAudio_' + xhr.status);
      };
      xhr.onabort = () => {
        reject('cancel');
      };
      xhr.upload.onabort = () => {
        reject('cancel');
      };
      xhr.onload = () => {
        resolve(JSON.parse(xhr.response));
      };
      xhr.send(formData);
      this.setState({ uploadXHR: xhr });
      this.props.onUploadXHRChange(xhr);
    });
  };

  requestUploadImageFile = (file, callback, guid) => {
    let action;
    if (this.props.type === 'image') {
      action = '34IC_UploadStart';
    } else if (this.props.type === 'audio') {
      action = '29AC_UploadStart';
    } else {
      action = '36VC_UploadStart';
    }
    sentGAEvent({
      category: 'UploadStart',
      action: action,
      label: 'Null',
    });
    const formData = new FormData();
    formData.append('files[]', file);
    formData.append('token', this.props.tokenId);
    // this.props.onUploadPercentChange(1);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${api_config.API_URL}/uploadImage`, true);
      xhr.setRequestHeader('authorization', this.props.authorization);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          // this.props.onUploadPercentChange(parseInt((event.loaded / event.total) * 100));
          callback(parseInt((event.loaded / event.total) * 100), guid);
        }
      };
      xhr.onerror = () => {
        reject('uploadImage_' + xhr.status);
      };
      xhr.onabort = () => {
        reject('cancel');
      };
      xhr.upload.onabort = () => {
        reject('cancel');
      };
      xhr.onload = () => {
        resolve(JSON.parse(xhr.response));
      };
      xhr.send(formData);
      this.setState({ uploadXHR: xhr });
      this.props.onUploadXHRChange(xhr);
    });
  };

  requstConvert = (convert, url) => {
    const formData = new FormData();
    formData.append('ext', convert);
    formData.append('file_url', url);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      request(`formatConv`, {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  handleChangeProgress = (processNum, guid) => {
    const files = [...this.props.files];
    files.forEach((item) => {
      if (item.guid === guid) {
        if (!item.proccess) {
          item.proccess = 0;
          item.proccessStep = 3;
        }
        if (item.proccess < 100) {
          item.proccess = parseInt(processNum);
        } else {
          item.proccess = parseInt(
            processNum + (item.proccess - (item.proccess % 100))
          );
        }
      }
    });
    this.props.onFilesChange(files);
  };

  render() {
    return (
      <ConvertWorkFunction
        accept={this.props.accept}
        files={this.props.files}
        fetchAbort={this.props.fetchAbort}
        uploadXHR={this.props.uploadXHR}
        onFilesChange={this.props.onFilesChange}
        handleConvert={this.handleSubmit}
        handleSubmitAgain={this.handleSubmitAgain}
        type={this.props.type}
        ref={this.convertChild}
      />
    );
  }
}

const mapStateToPropos = (state) => ({
  files: state.files.files,
  tokenId: state.common.tokenId,
  fetchAbort: state.work.fetchAbort,
  uploadXHR: state.work.uploadXHR,
  authorization: state.common.authorization,
});

const mapDispatchToProps = (dispatch) => ({
  onFilesChange: (files) => dispatch(actions.onFilesChange(files)),
  onUploadPercentChange: (files) =>
    dispatch(actions.onUploadPercentChange(files)),
  onUploadXHRChange: (uploadXHR) =>
    dispatch(actions.onUploadXHRChange(uploadXHR)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(ConvertWork);
